import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Nieuwe aanbieding aanmaken',
  subtitle: 'Hoe krijgt de klant een gratis item?',
  validation: {
    required: 'Selecteer een aanbiedingstype',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Totale orderwaarde',
      description: 'Bijv. 10% korting op uw bestelling bij een besteding van 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Geselecteerde items',
      description: "Bijv. 10% korting op pizza's van 12 inch.",
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Geselecteerde items',
      description: "Bijv. 1 {{currency}} korting op pizza's van 12 inch.",
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Totale orderwaarde',
      description: 'Bijv. 1 {{currency}} korting op uw bestelling bij een besteding van 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Koop 1, krijg 1 gratis',
      description: 'Bijv. Koop 1 pizza en krijg er een gratis. De goedkoopste pizza heeft korting.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Koop 1, krijg 1 voor halve prijs',
      description: 'Bijv. Koop 1 pizza en krijg er een voor halve prijs. De goedkoopste pizza heeft korting.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Door een ander item te kopen',
      description: 'Bijv. Gratis drankje bij het bestellen van een maaltijd.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Bij een vaste besteding van {{currency}}',
      description: 'Bijv. Gratis dessert bij een besteding van 20 {{currency}}.',
    },
  },
};
